
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import CdnImage from '../../shared/helpers/cdn-image';
import {SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';

@Component({
  name: 'catalog-product-list-item',
  components: ServiceContainer().getComponents(),
})

export default class extends Vue {
  @Prop({required: true}) readonly product: object;
  @Prop({required: false, default: false}) readonly hideModal: boolean;
  @Prop({default: null}) readonly type: string | null;
  @Prop({default: () => []}) private wishlistItems: Array<object>;

  private showModal: boolean = false;

  private get listTypeClass(): string {
    switch (this.type) {
      case 'home':
      case 'slider':
        return 'cell';
      case 'crosssell':
        return 'small-24 cell';
      default:
        return 'small-24 medium-12 large-6 cell';
    }
  }

  private get componentTag(): string {
    switch (this.type) {
      case 'slider':
      case 'crosssell':
        return 'div';
      default:
        return 'li';
    }
  }

  private get showCompareWidget(): boolean {
    return this.type !== 'home' && this.type !== 'crosssell';
  }

  private mounted(): void {
    this.$forceUpdate();
  }

  private addProductClick(): void {
    SolarDataLayer.init().addSelectItem(this.product, this.$vnode.key as number, 'Product list');
  }

  private updated(): void {
    this.$eventBus.$emit('item-rendered', true);
  }

  private handleAvailabilityBtn(): void {
    this.$eventBus.$emit('toggleAvailabilityBtn', this.product['product_id']);
    this.showModal = ! this.showModal;

    if (this.showModal) {
      document.body.classList.add('no-scrolling');
    } else {
      document.body.classList.remove('no-scrolling');
    }
  }

  private get labelValue(): string {
    if ( ! this.product.hasOwnProperty('labels') || ! this.product['labels'].length) {
      return '';
    }

    if (this.product['cashback_value'] && this.product['labels'][0]['label'] == 'Cashback') {
      return `&euro;${this.product['cashback_value']} ${this.product['labels'][0]['label']}`;
    }

    return this.product['labels'][0]['label'];
  }

  private get labelColor(): string {
    const defaultColor = '#ec660d';

    if (this.product.hasOwnProperty('labels') ? this.product['labels'].length : 0) {
      return this.product['labels'][0]['color'] || defaultColor;
    }

    return defaultColor;
  }

  private get imageSrc(): object {
    const image = this.product['default_image'];

    if (image) {
      return {
        default: CdnImage.url(image['url'], 204),
        retina: CdnImage.url(image['url'], 408),
      }
    }

    return {
      default: '/area/web/default/assets/images/logo-small.svg',
      retina: '/area/web/default/assets/images/logo-small.svg',
    };
  }

  private checkKey(e): void {
    e = e || window.event;
    if (e.which === 27 || e.keyCode === 27) {
      this.closeModal();
    }
  }

  private toggleModal(): void {
    this.showModal = ! this.showModal;
    document.body.classList.toggle('no-scrolling');
  }

  private closeModal(): void {
    this.showModal = false;
    document.body.classList.remove('no-scrolling');
  }

  private created(): void {
    document.addEventListener('keydown', this.checkKey);
  }
}
